import React, { useEffect } from 'react';

const WingoUnitWiki: React.FC = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Wingo - Wingipedia';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'A Wingo is a 320-meter track unit used in WINGO World for measuring distances and calculating performance metrics.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Full-width header section */}
      <div className="w-full bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:ml-36">
        {/* Mobile header and intro - appears first on mobile */}
        <div className="lg:hidden mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
              <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
                Wingo
            </h1>
              <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the WINGO World encyclopedia</p>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
                A <strong>Wingo</strong> is a 320-meter track unit used in WINGO World for measuring distances and mining <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> currency. The unit is named after the <a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a> and serves as the fundamental distance measurement within the 320 Track Club community. Participants run Wingos to mine <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> currency, with all activities recorded on the community ledger.
              </p>
            </div>
          </div>

        {/* Desktop header and intro */}
        <div className="hidden lg:block mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
            <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
              Wingo
            </h1>
            <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the free encyclopedia</p>
          </div>

          {/* Desktop bio image - positioned to float right */}
          <div className="hidden lg:block float-right ml-6 mb-6 w-80" style={{ fontFamily: 'Georgia, serif' }}>
            <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
              <div className="text-center mb-2">
                <span className="font-bold" style={{ fontSize: '14px' }}>Wingo</span>
              </div>
              
              <div className="text-center mb-2">
                <img 
                  src="/wingate1.jpg" 
                  alt="320-meter track distance" 
                  className="w-full h-56 object-cover rounded"
                  style={{ objectPosition: 'center' }}
                />
              </div>
              
              <div className="space-y-0.5">
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Distance:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>320 meters</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Type:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Track unit</span>
                </div>
          
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Usage:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Performance metrics</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Named for:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Wingate Track</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Plural:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Wingos</span>
                </div>
              </div>
            </div>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
              A <strong>Wingo</strong> is a 320-meter track unit used in WINGO World for measuring distances and mining <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> currency. The unit is named after the <a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a> and serves as the fundamental distance measurement within the 320 Track Club community. Participants run Wingos to mine <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> currency, with all activities recorded on the community ledger.
            </p>
          </div>

        </div>
        </div>
      </div>

      {/* Frozen Contents - Desktop only */}
      <div className="hidden lg:block fixed top-36 left-4 w-44 z-10">
        <div className="bg-white p-3" style={{ fontFamily: 'Georgia, serif' }}>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-sm font-bold">Contents</h2>
                <button className="text-xs text-blue-600 hover:underline">[hide]</button>
              </div>
              <ol className="list-decimal list-inside space-y-0.5 text-xs">
                <li><a href="#overview" className="text-blue-600 hover:underline">Overview</a></li>
                <li><a href="#measurement" className="text-blue-600 hover:underline">Measurement system</a></li>
                <li><a href="#usage" className="text-blue-600 hover:underline">Usage in WINGO World</a></li>
                <li><a href="#conversion" className="text-blue-600 hover:underline">Conversion factors</a></li>
                <li><a href="#see-also" className="text-blue-600 hover:underline">See also</a></li>
              </ol>
            </div>
          </div>

      {/* Main content area with proper positioning */}
      <div className="w-full py-1">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 lg:ml-36">
          {/* Main content - sections that wrap around bio image */}
          <div className="lg:mr-0">

            {/* Mobile bio image - appears after table of contents */}
            <div className="block lg:hidden mb-6">
              <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
                <div className="text-center mb-2">
                  <span className="font-bold" style={{ fontSize: '14px' }}>Wingo</span>
                </div>
                
                <div className="text-center mb-2">
                  <img 
                    src="/wingate1.jpg" 
                    alt="320-meter track distance" 
                    className="w-full h-56 object-cover rounded"
                    style={{ objectPosition: 'center' }}
                  />
                </div>
                
                <div className="space-y-0.5">
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Distance:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>320 meters</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Type:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Track unit</span>
                  </div>
            
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Usage:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Performance metrics</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Named for:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Wingate Track</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Plural:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Wingos</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Overview section */}
            <section id="overview" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>
                <span className="block w-full lg:inline lg:max-w-[calc(100%-350px)]">Overview</span>
              </h2>
              
              <p className="mb-3 text-base">
                The Wingo serves as the fundamental unit of distance measurement within WINGO World, providing a standardized way to calculate performance metrics, training distances, and race measurements. The 320-meter distance was chosen to honor the Historic Wingate Track and create a unique measurement system that reflects the community's values and heritage.
              </p>
              
              <p className="mb-3 text-base">
                Unlike traditional metric or imperial measurements, the Wingo system creates a distinct identity for the WINGO World community while maintaining practical utility for athletic performance tracking and economic calculations.
              </p>

              <p className="mb-3 text-base">
                The term "Wingo" is distinct from WINGO, the cryptocurrency used in WINGO World. While "Wingos" (plural) refers to track distances, "WINGO" (always singular) refers to the digital currency.
              </p>

            </section>

            {/* Measurement system section */}
            <section id="measurement" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Measurement system</h2>
              
              <p className="mb-3 text-base">
                The Wingo measurement system is based on the 320-meter distance, which corresponds to approximately 0.2 miles or 1,050 feet. This distance was selected for its practical utility in track training and its symbolic connection to the Historic Wingate Track.
              </p>
              
              <p className="mb-3 text-base">
                Common Wingo measurements include:
              </p>

              <ul className="list-disc list-inside space-y-1 mb-3 ml-4 text-base">
                <li><span className="font-medium">Wingito</span> — 160 meters (half Wingo)</li>
                <li><span className="font-medium">Wingo</span> — 320 meters</li>
                <li><span className="font-medium">Twingo</span> — 640 meters (double Wingo)</li>
                <li><span className="font-medium">Tringo</span> — 960 meters (triple Wingo)</li>
                <li><span className="font-medium">PentaWingo</span> — 1,600 meters (5 Wingos)</li>
                <li><span className="font-medium">DecaWingo</span> — 3,200 meters (10 Wingos)</li>
              </ul>
            </section>

            {/* Usage in WINGO World section */}
            <section id="usage" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Usage in WINGO World</h2>
              
              <div className="float-right ml-4 mb-3 w-56 lg:block hidden bg-gray-50 p-2 rounded">
                <a href="/wingo_segment.png" target="_blank" rel="noopener noreferrer" className="block">
                  <img 
                    src="/wingo_segment.png" 
                    alt="Wingo track segment showing 320-meter distance" 
                    className="w-full h-auto hover:opacity-90 transition-opacity cursor-pointer border border-gray-300 rounded"
                  />
                </a>
                <p className="text-xs text-gray-600 italic mt-1" style={{ fontSize: '10px', lineHeight: '1.2' }}>
                  Wingo track segment showing 320-meter distance
                </p>
              </div>

              {/* Mobile version - smaller, still floating */}
              <div className="float-right ml-3 mb-3 w-52 block lg:hidden bg-gray-50 p-2 rounded">
                <a href="/wingo_segment.png" target="_blank" rel="noopener noreferrer" className="block">
                  <img 
                    src="/wingo_segment.png" 
                    alt="Wingo track segment showing 320-meter distance" 
                    className="w-full h-auto hover:opacity-90 transition-opacity cursor-pointer border border-gray-300 rounded"
                  />
                </a>
                <p className="text-xs text-gray-600 italic mt-1 pl-1" style={{ fontSize: '8px', lineHeight: '1.1' }}>
                  Wingo track segment showing 320-meter distance
                </p>
              </div>
              
              <p className="mb-3 text-base">
                Wingos are used throughout WINGO World for various purposes:
              </p>

              <ul className="list-disc list-inside space-y-1 mb-3 ml-4 text-base">
                <li><span className="font-medium">Training distances</span> — Workouts are often prescribed in Wingos for consistency and community identity.</li>
                <li><span className="font-medium">Performance tracking</span> — Race times and training sessions are measured in Wingos to maintain the community's unique measurement system.</li>
                <li><span className="font-medium">Economic calculations</span> — WINGO currency rewards may be calculated based on Wingos completed during training or racing.</li>
                <li><span className="font-medium">Community events</span> — Races and challenges are often organized around Wingo distances to reinforce the community's identity.</li>
              </ul>
            </section>


            {/* See also */}
            <section id="see-also" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>See also</h2>
              <ul className="list-disc list-inside space-y-1 text-base">
                <li><a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO Currency</a></li>
                <li><a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a></li>
                <li><a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Coach DAISY™</a></li>
              </ul>
            </section>
              </div>
        </div>
      </div>
    </div>
  );
};

export default WingoUnitWiki;
